import { CULTIVATION_TYPES } from "../../../../../config/optionsConstants";

export const CULTIVATION_DATA_TYPE_OPTIONS = CULTIVATION_TYPES.map(o => ({
  value: o.value,
  label: o.text
}));
